import React, { Component } from 'react';
import { createMainController } from '../../../services/createMainController';
import IndustryPage from '../../../components/IndustryPage/IndustryPage';
import { biLogSafe } from '../../../../universal/biService';

class IndustryController extends Component {
  componentDidMount() {
    const { lastLocation, selectors } = this.props;
    const referralInfo = selectors.getReferralInfo();
    if (lastLocation && lastLocation.pathname === '/') {
    }
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorPageOpen', { origin: referralInfo, pageName: 'Industry' });
    });
  }

  getAutocomplete = async term => {
    const {
      services: { industryService }
    } = this.props;

    const fetchedIndustries = await industryService.getIndustrySuggestions(term);
    return fetchedIndustries;
  };

  onNextHandler = () => {
    const { goToBusinessNamePage, selectors } = this.props;
    const referralInfo = selectors.getReferralInfo();
    const industryText = selectors.getIndustryText();
    goToBusinessNamePage();
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Industry',
        buttonName: 'Next',
        additionalInfo: JSON.stringify({ industry: industryText })
      });
    });
  };

  textChangedHandler = text => {
    const { setIndustry } = this.props;
    const industryText = text && text.substring(0, 100);
    setIndustry(industryText, industryText, true);
  };

  industrySelectHandler = industry => {
    const { setIndustry } = this.props;
    setIndustry(industry.id, industry.label, false);
  };

  onSkipClick = (...args) => {
    const { skipIndustryPage, selectors } = this.props;
    const referralInfo = selectors.getReferralInfo();
    const industryText = selectors.getIndustryText();
    skipIndustryPage(...args);
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        origin: referralInfo,
        pageName: 'Industry',
        buttonName: 'Skip',
        additionalInfo: JSON.stringify({ industry: industryText })
      });
    });
  };

  emptycall() {}
  render() {
    const { t, industries } = this.props;
    const { selectors } = this.props;
    const industryText = selectors.getIndustryText();

    return (
      <IndustryPage
        industries={industries}
        text={industryText}
        onIndustrySelect={this.industrySelectHandler}
        onTextChanged={this.textChangedHandler}
        onNext={this.onNextHandler}
        onSkip={this.onSkipClick}
        getAutocomplete={this.getAutocomplete}
        placeHolderText={t('BNG_ON_BOARDING_INDUSTRY_PLACE_HOLDER')}
        nextButtonText={t('BNG_ON_BOARDING_NEXT_BUTTON')}
        skipButtonText={t('BNG_ON_BOARDING_SKIP_BUTTON')}
      />
    );
  }
}

export default createMainController(IndustryController);
